import './App.css';
import NavBar from '../navBar/NavBar';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthenticationProvider from '../auth/AuthenticationProvider';
import ProtectedRoute from '../protectedRoute/ProtectedRoute';
import ErrorHandler from '../error/ErrorHandler';
import Zendesk from '../zendesk/Zendesk';
import { requiresFluidContainer } from './fluidContainer';

const App = (): JSX.Element => {
  const location = useLocation();

  if (location.pathname === '/') {
    return <Navigate to={'users'} state={{ from: location }} />;
  }

  return (
    <ErrorHandler>
      <AuthenticationProvider>
        <div className={requiresFluidContainer(location.pathname) ? 'container-fluid' : 'container'}>
          <Zendesk>
            <NavBar />
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          </Zendesk>
        </div>
      </AuthenticationProvider>
    </ErrorHandler>
  );
};

export default App;
